<template>
    <common-content-spacer height="small">
        <div class="discounts">
            <common-content-spacer height="medium">
                <common-page-header :isCenter="true" :heading="$t('forms.offer.discount_offer.discount')"></common-page-header>
                <common-buttons align="right">
                    <common-button
                        type="primary"
                        size="tiny-micro"
                        :isSubmittable="false"
                        :label="$t('pages.company.my_company.buttons.add_discount')"
                        @click="openDiscountModal()"
                    ></common-button>
                </common-buttons>
                <common-table v-if="discountsList?.length">
                    <thead>
                        <tr>
                            <th class="table--category">
                                {{ $t('forms.offer.discount_offer.table.category') }}
                            </th>
                            <th class="table--title">
                                {{ $t('forms.offer.discount_offer.table.title') }}
                            </th>
                            <th class="table--date-from">
                                {{ $t('forms.offer.discount_offer.table.date_from') }}
                            </th>
                            <th class="table--date-to">
                                {{ $t('forms.offer.discount_offer.table.date_to') }}
                            </th>
                            <th class="table--percentage">
                                {{ $t('forms.offer.discount_offer.table.percentage') }}
                            </th>
                            <th class="table--action">
                                {{ $t('forms.offer.discount_offer.table.actions') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in discountsList" :key="item.id">
                            <td :data-label="$t('forms.offer.discount_offer.table.category')">
                                {{ getTranslation(item.offerCategory.titleTextContent) }}
                            </td>
                            <td :data-label="$t('forms.offer.discount_offer.table.title')" class="table--title">
                                {{ item.title }}
                            </td>
                            <td :data-label="$t('forms.offer.discount_offer.table.date_from')">{{ item.dateFrom }}</td>
                            <td :data-label="$t('forms.offer.discount_offer.table.date_to')">{{ item.dateTo }}</td>
                            <td :data-label="$t('forms.offer.discount_offer.table.category')">
                                {{ item.discountPercentage * 100 }}%
                            </td>
                            <td :data-label="$t('forms.offer.discount_offer.table.actions')" class="table--action">
                                <span>
                                    <common-icon name="reservation" size="medium" @click="editDiscount(item)"></common-icon>
                                    <common-icon
                                        name="trash"
                                        size="medium"
                                        @click="openRemoveDiscountModal(item.id)"
                                    ></common-icon>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </common-table>
                <div v-else class="discounts--warning">{{ $t('forms.offer.discount_offer.warning') }}</div>
            </common-content-spacer>
        </div>
        <add-offer-discount-modal
            v-if="isAddOfferDiscountModalOpen"
            :offers="offers"
            :prefill="discount"
            @close="closeDiscountModal"
            @discount-added="onDiscountAdded"
        ></add-offer-discount-modal>
        <common-yes-no-modal
            v-if="isDeleteDiscountModalOpen"
            :showWarningIcon="true"
            height="tiny"
            :headingText="$t('modals.delete_discount.title')"
            :noButtonText="$t('common.microcopy.false')"
            :yesButtonText="$t('common.microcopy.true')"
            @close="isDeleteDiscountModalOpen = false"
            @continue="removeDiscount()"
        ></common-yes-no-modal>
    </common-content-spacer>
</template>

<script>
    import OfferAPI from 'api/OfferAPI'
    import AddOfferDiscountModal from 'components/page-elements/offer/AddOfferDiscountModal.vue'
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [TranslateMixin],

        components: {
            AddOfferDiscountModal,
        },
        props: {
            discountsList: { type: Array, default: undefined },
            offers: { type: Array, required: true },
        },
        data() {
            return {
                isAddOfferDiscountModalOpen: false,
                isDeleteDiscountModalOpen: false,
                discount: {},
                discountId: undefined,
            }
        },

        inject: ['isCompany'],

        computed: {
            isServiceForCompany() {
                return !!this.prefill.location.companyServiceProvider
            },
        },

        methods: {
            openDiscountModal() {
                this.isAddOfferDiscountModalOpen = true
            },

            onDiscountAdded() {
                this.closeDiscountModal()
                this.emitEvent({ name: 'discounts-changed' })
            },

            closeDiscountModal() {
                this.discount = undefined
                this.isAddOfferDiscountModalOpen = false
            },

            openRemoveDiscountModal(id) {
                this.discountId = id
                this.isDeleteDiscountModalOpen = true
            },

            removeDiscount() {
                this.isLoading = true
                const req = this.isCompany ? OfferAPI.deleteCompanyDiscount : OfferAPI.deleteUserDiscount
                req(this.discountId, this.$route.params.id)
                    .then(() => {
                        this.discountId = undefined
                        this.isDeleteDiscountModalOpen = false
                        this.emitEvent({ name: 'discounts-changed' })
                    })
                    .catch(() => {
                        this.$toast.error(this.$t('common.errors.common_error'))
                    })
            },

            editDiscount(discount) {
                this.discount = discount
                this.openDiscountModal()
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .discounts {
        .table {
            &--action {
                .icon {
                    cursor: pointer;
                    margin-right: 10px;

                    &:hover {
                        color: $color--accent-1;
                    }
                }
            }
        }

        &--warning {
            color: $color--accent-4;
        }
    }
</style>
